import { Button } from "baseui/button";
import {  DeleteRelationsCommand, RELATION_TYPE,  useDeleteRelationMutation } from "../../../services/objects";
import { CO2RateListItem, CostRateListItem, schemaCO2Rate,   EditEnergyRateButton, schemaCostRate,} from "../../Energy/EnergyRates";
import { IBaseCounter } from "./types";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { GoUnlink } from "react-icons/go";


interface ReferencedRatesListProps extends IBaseCounter {
    item: any,
    rateModelId?: string,
    onUnlinked: () => void,
}

const ReferencedRate = (props: ReferencedRatesListProps) => {
    const item = props.item;
    return (
        <>
            {item.schema === schemaCO2Rate ? <CO2RateListItem  {...item}
                endEnhancers={
                    <>
                        <EditEnergyRateButton  {...item}></EditEnergyRateButton>
                        <UnlinkButton onUnlinked={props.onUnlinked} counterId={props.id} resourceGroupId={props.resourceGroupId} energyRateId={item.id} relationType={'Co2Rate'}></UnlinkButton>
                    </>
                }
            />
            :
             <CostRateListItem   {...item}
                endEnhancers={
                    <>
                        <EditEnergyRateButton  {...item}></EditEnergyRateButton>
                        <UnlinkButton onUnlinked={props.onUnlinked} counterId={props.id} resourceGroupId={props.resourceGroupId} energyRateId={item.id} relationType={'CostRate'}></UnlinkButton>
                    </>
                } />}

        </>
    )
}


export default ReferencedRate

const UnlinkButton = (props: { counterId: string, energyRateId: string, resourceGroupId: string, relationType: keyof typeof RELATION_TYPE, onUnlinked?: () => void }) => {
    const [deleteRealtion, deleteRealtionResult] = useDeleteRelationMutation();
    useReportMutationState(deleteRealtionResult, props.onUnlinked);

    const handleOkClick = () => {
        const cmd: DeleteRelationsCommand = {
            fromObjectId: props.counterId,
            toObjectId: props.energyRateId,
            resourceGroupId: props.resourceGroupId,
            type: props.relationType
        }
        deleteRealtion(cmd);
    }
    return (<Button shape='circle' kind='secondary' onClick={handleOkClick} isLoading={deleteRealtionResult.isLoading}><GoUnlink></GoUnlink></Button>)
}

